module.exports = __webpack_public_path__ + "static/media/santiago_martin_lugones.8d79a08d.jpg";